import React, { createContext, ReactNode, useContext } from 'react';
import { useODataMultipleQueries } from '../../customHooks/useODataMultipleQueries';
import { readOnlyEntities } from '../../utils/commonVariables/entityKeys';
import { IZinantisConnectionRequestStatusType } from '../../types/entities/IZinantisConnectionRequestStatusType';

interface QueryResult {
    count: number;
    data: any[];
    error: any | null;
    isLoading: boolean;
}
interface ConnectionRequestsAuxiliaryDataContextType {
    statuses: QueryResult;
    agencies: QueryResult;
}

const Context = createContext<
    ConnectionRequestsAuxiliaryDataContextType | undefined
>(undefined);

export const ProviderConnectionRequestsAuxiliaryData = ({
    children,
}: {
    children: ReactNode;
}) => {
    const queries = [
        {
            key: 'statuses',
            endpoint: {
                entityName:
                    readOnlyEntities.ZinantisConnectionRequestStatusType,
                select: ['Id', 'LocalizedCaption', 'Caption', 'Name', 'Color'],
                filter: [`Enabled eq true`],
                orderBy: 'LocalizedCaption asc',
            },
            transform: (items: IZinantisConnectionRequestStatusType[]) => {
                return items.map(item => ({
                    Id: item.Id,
                    label: item.LocalizedCaption || item.Caption || item.Name,
                    color: item.Color,
                }));
            },
        },
        {
            key: 'agencies',
            endpoint: {
                entityName: readOnlyEntities.Agency,
                select: ['Id', 'Name'],
                filter: [`ZinantisMembership eq true`],
                orderBy: 'Name asc',
            },
        },
    ];

    const { statuses, agencies } = useODataMultipleQueries({
        queries,
        dependencies: [],
    });

    return (
        <Context.Provider value={{ statuses, agencies }}>
            {children}
        </Context.Provider>
    );
};

export const useConnectionRequestsAuxiliaryData = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error(
            'useConnectionRequestsAuxiliaryData must be used within a ProviderConnectionRequestsAuxiliaryData'
        );
    }
    return context;
};
